import React from "react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";

export class LoyaltyBarSideMenuLink extends OrbitComponent {
    render() {
        /**
         * TODO: Review colors and fonts here and refactor. Move loyalty bar to Orbit and use styled-components
         */
        return <div className="cgp-directive-loyalty"
            onClick={this.onClick}
            data-backgroundColor="transparent"
            data-fontSize="12"
            data-textColor="#717171"
            data-showBoxShadow="false"
            data-showUnderline="false"
            data-arrowSize="8"
            data-progressBarBackgroundColor="#171717"
            data-arrowColor="#7b7b7b"
            data-font='"888-DemiBold\",verdana,sans-serif'
            data-progressBarHeight="4"
            data-lolContentPaddingLeft="0"
            data-lolArrowTop="-3px"
        />;
    }
    onClick = () => {
        this.services.analytics.sendAnalytics('Navigation', 'NavBar', 'Loyalty_Bar');
    };

}
